import { withTranslation } from 'react-i18next'
import Finance from './Finance'

export default withTranslation()(Finance)
